import React, { useState } from 'react';
import UniversalSidebar from '../navigation/UniversalSidebar';
import { getBulletinSidebarItems } from '../navigation/sidebarConfigs';
import useAutoExpandSidebar from '../../hooks/useAutoExpandSidebar';
import PublicCasefiles from './PublicCasefiles';
import PublicEvidenceTab from './PublicEvidenceTab';
import BulletinActivityTab from './BulletinActivityTab';
import RecentUploadsTab from './RecentUploadsTab';
import TrendingCasesTab from './TrendingCasesTab';
import '../../styles/Bulletin.css';
import '../../styles/BulletinTabs.css';

const Bulletin = ({ sidebarOpen, onSidebarToggle }) => {
  const [activeTab, setActiveTab] = useState('public-evidence');

  // Use auto-expand sidebar hook for the bulletin sidebar
  const {
    isOpen: isBulletinSidebarOpen,
    shouldAutoExpand: bulletinShouldAutoExpand,
    sidebarMode: bulletinSidebarMode,
    handleToggle: handleBulletinSidebarToggle
  } = useAutoExpandSidebar(sidebarOpen);

  // Sync external sidebar state with internal hook
  const handleSidebarToggle = (newState) => {
    if (onSidebarToggle) {
      onSidebarToggle(newState);
    }
    handleBulletinSidebarToggle(newState);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'public-casefiles':
        return <PublicCasefiles />;
      case 'public-evidence':
        return <PublicEvidenceTab />;
      case 'bulletin-activity':
        return <BulletinActivityTab />;
      case 'recent-uploads':
        return <RecentUploadsTab />;
      case 'trending':
        return <TrendingCasesTab />;
      case 'community':
        return (
          <div className="tab-content">
            <div className="tab-header">
              <h2>Community</h2>
              <p>Community highlights and features</p>
            </div>
            <p>Community features coming soon...</p>
          </div>
        );
      case 'search-advanced':
        return (
          <div className="tab-content">
            <div className="tab-header">
              <h2>Advanced Search</h2>
              <p>Advanced search and filtering options</p>
            </div>
            <p>Advanced search functionality coming soon...</p>
          </div>
        );
      case 'featured':
        return (
          <div className="tab-content">
            <div className="tab-header">
              <h2>Featured Cases</h2>
              <p>Featured and highlighted cases</p>
            </div>
            <p>Featured cases functionality coming soon...</p>
          </div>
        );
      case 'global-stats':
        return <BulletinActivityTab />;
      case 'bounties':
        return (
          <div className="tab-content">
            <div className="tab-header">
              <h2>Bounties</h2>
              <p>Rewards and bounties for solving cases</p>
            </div>
            <p>Bounties functionality coming soon...</p>
          </div>
        );
      default:
        return <PublicCasefiles />;
    }
  };

  const sidebarItems = getBulletinSidebarItems(activeTab, setActiveTab);
  
  const communityStatus = (
    <div className="community-status">
      <div className="status-indicator online"></div>
      <span>Community Active</span>
    </div>
  );

  return (
    <div className={`bulletin-container ${bulletinShouldAutoExpand ? 'content-with-auto-sidebar' : ''}`}>
      <UniversalSidebar
        isOpen={isBulletinSidebarOpen}
        onToggle={handleSidebarToggle}
        items={sidebarItems}
        activeItem={activeTab}
        title="Bulletin Board"
        subtitle="Community Intelligence Hub"
        footer={communityStatus}
        sidebarMode={bulletinSidebarMode}
        shouldAutoExpand={bulletinShouldAutoExpand}
      />
      <div className="bulletin-content">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default Bulletin; 